<template>
      <div class="pageEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'page', params: {} }">
          Page
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'pageEdit', params:{id: id} }">
            Edit Page
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Page</v-card-title>
          <v-card-text>
            <page-form :id="id"></page-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import PageForm from './PageForm.vue';

    export default {
      name: 'page',
      data () {
        return {
          id: null
        }
      },
      components: {
        PageForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    